import React from "react";
import styled from "styled-components";

import { LogoGreen } from "../components/images";

const Foot = styled.footer`
  position: fixed;
  bottom: 0;
  padding: 40px;
  color: #005a4b;
  font-weight: bold;
  text-transform: uppercase;

  @media screen and (max-width: 500px) {
    padding: 20px;
  }
`;

function Footer() {
  return (
    <Foot>
      <LogoGreen></LogoGreen>
    </Foot>
  );
}

export default Footer;
